var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCloudSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.63 20.83H5.54c-2.94-.21-4.26-2.48-4.26-4.49 0-1.8 1.05-3.8 3.33-4.35-1-3.84.9-6.53 3.14-7.8 2.6-1.48 6.47-1.49 8.82 1.36l.06.09c.7.89 1.19 1.96 1.47 3.2 1.23.27 2.29.93 3.12 1.91 1.89 2.23 2.25 6.11-.45 8.49a6.023 6.023 0 0 1-4.1 1.59h-.04zM8.5 5.49c-2.42 1.38-3.24 3.94-2.2 6.86.08.23.05.49-.09.68-.14.19-.37.32-.61.32-1.94.14-2.81 1.6-2.81 2.99 0 1.39.87 2.85 2.81 3h11.04c1.16.01 2.28-.42 3.13-1.2l.01-.01c2.03-1.78 1.73-4.71.3-6.4-.7-.83-1.63-1.34-2.7-1.48a.732.732 0 0 1-.64-.62c-.21-1.24-.65-2.28-1.31-3.1-.02-.02-.03-.05-.05-.07-1.06-1.24-2.48-1.76-3.89-1.76-1.06 0-2.11.29-2.99.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93 13.68c-.42-.21-.88-.32-1.35-.33a.762.762 0 0 1-.74-.76c.01-.41.4-.75.76-.74.69.01 1.38.18 1.99.49.37.18.52.64.34 1.01a.742.742 0 0 1-1 .33zM15.18 10.25a.754.754 0 0 1 .34-1.01c.62-.31 1.31-.48 1.99-.49.4-.01.76.32.76.74.01.41-.32.76-.74.76-.46.01-.93.12-1.35.33-.11.06-.22.09-.33.09-.28 0-.54-.15-.67-.42z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.07 11.71a4.16 4.16 0 0 0-2.7-1.48.732.732 0 0 1-.64-.62c-.21-1.24-.65-2.28-1.31-3.1a.733.733 0 0 1-.17-.47c0-.2.08-.4.22-.54.8-.81 1.86-1.25 3-1.25a4.26 4.26 0 0 1 4.25 4.25c0 1.3-.58 2.51-1.6 3.32a.759.759 0 0 1-1.05-.11zm.59-1.55a2.748 2.748 0 0 0-2.19-4.41c-.52 0-1.02.14-1.45.42.51.77.87 1.67 1.09 2.67.96.21 1.83.66 2.55 1.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCloudSunny);
export default __webpack_public_path__ + "static/media/vuesax-outline-cloud-sunny.3b33060e9cd256491582730a982e229a.svg";
export { ForwardRef as ReactComponent };